module.exports = __webpack_public_path__ + "static/img/IMG_20150306_144934.9eb70aef.jpg";